// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__+ZtW4","loaderContainer":"Loader_loaderContainer__tzk8i"};